// extracted by mini-css-extract-plugin
module.exports = {"chooseApp":"styles_chooseApp__KM3hc","apps":"styles_apps__1gdOQ"};